import { JSX } from 'react'

import { IconProps } from '../../icon'

const InProgress: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_671_65)'>
      <path
        d='M16.0141 32C24.8507 32 32.0141 24.8366 32.0141 16C32.0141 7.16344 24.8507 0 16.0141 0C7.17754 0 0.0140991 7.16344 0.0140991 16C0.0140991 24.8366 7.17754 32 16.0141 32Z'
        fill='#FFBE00'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.63998 25.6376C6.56469 25.6376 6.48939 25.6 6.45175 25.5623C6.37645 25.487 6.37645 25.3741 6.37645 25.2612L8.29645 19.5388L12.4753 23.7176L6.75292 25.6C6.71528 25.6 6.67763 25.6376 6.63998 25.6376ZM12.4 19.84C12.3623 19.84 12.287 19.84 12.2117 19.7647C12.1365 19.6518 12.1365 19.5012 12.2117 19.3882L18.687 12.9506C18.8 12.8376 18.9506 12.8376 19.0635 12.9506C19.1765 13.0635 19.1765 13.2141 19.0635 13.327L12.5882 19.7647C12.5506 19.84 12.4753 19.84 12.4 19.84ZM8.59763 19.0494L18.8376 8.8094L23.2047 13.1765L12.9647 23.4165L8.59763 19.0494ZM19.2517 8.43293L20.1176 7.5294C20.7953 6.85176 21.6612 6.47529 22.527 6.39999C23.4306 6.3247 24.2588 6.58823 24.8235 7.15293L24.8988 7.22823C25.3882 7.71764 25.6517 8.43293 25.6517 9.18587C25.6517 10.1647 25.2376 11.1435 24.4847 11.8588L23.5812 12.8L19.2517 8.43293Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_671_65'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.0140991)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default InProgress
